export default import.meta.ROLLUP_FILE_URL_abeIogWE3n2MBQ6xU5CKjw